import {EntityModel} from "@fedeltapointofsale/data-client";
import {SiteData} from "./site.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SiteEntityModel extends EntityModel<SiteData> {
    constructor(injector: Injector) {
        super(injector, SiteData);
    }
}
